import React from "react";

function Blog() {
  return (
    <div className="flex justify-center items-center text-center m-auto h-screen">
      <div className="flex flex-col justify-center text-center items-center">
        <h1 className="text-6xl">Pardon our dust</h1>
        <p className="text-2xl">My blog is still under construction.</p>
        {/* TODO build this with Wordpress */}
      </div>
    </div>
  );
}

export default Blog;
